export const ShipConfig = {
    dropOff: {
        ups: {
            us: {
                maxInsuredValue: 50000,
                maxInsuredValueCurrency: 'USD',
            },
        },
    },
    pickupLocation: {
        ups: {
            us: {
                cvsMichaels: {
                    maxCoverageValue: 10000,
                    maxCoverageCurrency: 'USD',
                },
                upsStore: {
                    maxCoverageValue: 70000,
                    maxCoverageCurrency: 'USD',
                },
            },
        },
        fedex: {
            us: {
                fedexLocation: {
                    maxCoverageValue: 70000,
                    maxCoverageCurrency: 'USD',
                },
            },
        },
    },
    forbiddenZipCodes: {
        enabled: false,
        data: [
            {
                countryCode: 'US',
                enabled: true,
                zipCodes: ['91001', '91009', '91003', '90272', '90049', '90401', '90402', '90265', '91011', '91012', '91023'],
            },
        ],
    },
};
